var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 20,
    height: 15,
    rx: 2,
    fill: "#003B6F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.4375C2 19.2969 2.625 20 3.38889 20H20.6111C21.375 20 22 19.2969 22 18.4375V12.5H2V18.4375ZM7.55556 16.25H10.8889V17.5H7.55556V16.25ZM4.22222 16.25H6.44444V17.5H4.22222V16.25ZM20.6111 5H3.38889C2.625 5 2 5.70313 2 6.5625V8.75H22V6.5625C22 5.70313 21.375 5 20.6111 5Z",
    fill: "#FFD058"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/CreditCardIcon.482567e74e1b02869bb947c87cc7f650.svg";
export { ForwardRef as ReactComponent };